import { render, staticRenderFns } from "./LogoBanner.vue?vue&type=template&id=1dcc6b59&scoped=true"
import script from "./LogoBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LogoBanner.vue?vue&type=style&index=0&id=1dcc6b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc6b59",
  null
  
)

export default component.exports